export enum RegisterStepType {
    RegisterData = "registerdata",
    CompanyResponsibles = "companyresponsibles",
    FirstLimit = "firstlimit",
    ResponsibleDocuments = "responsibledocuments",
    MoreInfo = "moreinfo",
    SecondLimit = "secondlimit",
    CompanyDocuments = "companydocuments",
    RegisterConfirm = "registerconfirm"
}
